import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { App } from './App.js';
import { queryClient } from './lib/query-client.js';
import { initSentry } from './lib/sentry.js';
import { SentryErrorBoundary } from './components/sentry-boundary.js';
// Importa pra garantir que o singleton seja avaliado depois de initSentry().
// Features podem importar { appLogger } from './lib/app-logger.js' diretamente.
import './lib/app-logger.js';
import './styles/globals.css';
import { applyTheme, readPersistedTheme } from './features/settings/useTheme.js';

// Aplica o tema antes do React montar pra evitar flash quando o usuário
// persistiu 'light'. O html já vem com classe 'dark' por default no index.html,
// então só sobrescreve quando há valor persistido divergente.
applyTheme(readPersistedTheme());

initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

createRoot(rootEl).render(
  <StrictMode>
    <SentryErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster richColors position="top-right" />
      </QueryClientProvider>
    </SentryErrorBoundary>
  </StrictMode>,
);
